module.exports = __webpack_public_path__ + "img/aboutUs_img6.ae298dc8.svg";